import { z } from "zod";
import { PASSWORD, USERNAME } from "./consts";

export const schema = z.object({
  [USERNAME]: z.string().min(1, "Invalid Username"),
  [PASSWORD]: z.string().min(8, "Invalid Password"),
});

export type formValues = z.infer<typeof schema>;
